<template>
    <div>

        <PageRowSeparator
            v-if="name"
            :text="name"
            class="mb-2 w-1/"
            :heading-tag="headingTag"
            :url="url"
        />

        <div class="flex flex-wrap lg:flex-nowrap lg:items-center gap-4">

            <div
                v-for="(tile, index) in tiles"
                :key="index"
                :class="rowWidthClassString(tile)"
                class="w-full mb-4 flex-grow"
            >
                <CatalogueTileGridMobile
                    v-if="tile.is_grid_mobile"
                    :items="tile.items"
                />

                <CatalogueTileCarousel
                    v-else-if="doesTileHasMoreThanOneItem(tile) && !tile.is_grid"
                    :items="tile.items"
                />

                <CatalogueTileGrid
                    v-else-if="tile.is_grid"
                    :items="tile.items"
                />

                <CatalogueTile
                    v-else-if="tile.items[0]"
                    :image="imageSize(tile.items[0].image)"
                    :hover-image="imageSize(tile.items[0].hover_image)"
                    :medium-image="imageSize(tile.items[0].medium_image)"
                    :small-image="imageSize(tile.items[0].small_image)"
                    :title="tile.items[0].title"
                    :is-new="tile.items[0].is_new"
                    :link="tile.items[0].url"
                    :external-link="tile.items[0].url.charAt(0) !== '/'"
                    :content="tile.items[0].content"
                    :shipping-class-id="tile.items[0].shipping_class_id"
                    :show-postcode-checker="tile.items[0].show_postcode_checker"
                />

            </div>

        </div>

    </div>
</template>

<script>
import CatalogueTileCarousel from '~/components/CatalogueTileCarousel';
import CatalogueTileGrid from '~/components/CatalogueTileGrid';
import CatalogueTileGridMobile from '~/components/CatalogueTileGridMobile';
import CatalogueTile from '~/components/CatalogueTile';
import PageRowSeparator from '~/components/PageRowSeparator';

export default {

    components: {
        CatalogueTileCarousel,
        CatalogueTileGrid,
        CatalogueTileGridMobile,
        CatalogueTile,
        PageRowSeparator,
    },

    props: {
        name: {
            type: String,
            default: null,
        },
        tiles: {
            type: Array,
            required: true,
        },
        headingTag: {
            type: String,
            default: 'h1',
        },
        url: {
            type: String,
            default: null,
        },
    },

    computed: {
        tileCount() {
            return this.tiles.length;
        },

    },

    methods: {
        rowWidthClassString(tile) {
            const classes = [];

            if (tile.width) {
                classes.push(`lg:w-${tile.width}`);
            } else {
                classes.push(`lg:w-1/${this.tileCount}`);
            }

            return classes;
        },
        doesTileHasMoreThanOneItem(tile) {
            return tile.items.length > 1;
        },
        imageSize(image) {
            if (!image) return;
            return image.sizes.large;
        },
    },

};
</script>

<style>
</style>
